import z from 'zod';

export const productEditDataSchema = z.object({
  code: z.string().optional(),
  displayName: z.string().optional(),
  productAlias: z.string().optional(),
  shortDescription: z.string().optional(),
  description: z.string().optional(),
  cost: z.number().optional(),
  salesPrice: z.number().optional(),
  commissionAmount: z.number().optional(),
  commissionIsPercent: z.boolean().default(false).optional(),
  netProfit: z.number().optional(),
  leslyLili: z.number().optional(),
  category: z.string().optional(),
});

export type ProductEditData = z.infer<typeof productEditDataSchema>;
